import {
  screenSmMax,
  spacer24,
  FormGroup,
  cssColorValue,
} from '@spotify-internal/encore-web';

import styled from 'styled-components';

const FieldGroup = styled(FormGroup)`
  max-width: 436px;
  margin: ${spacer24} 0;
`;

const RedirectPodcastParagraph = styled.p`
  margin: 24px 0;
  color: ${cssColorValue('textSubdued')};
  font-size: 1rem;
`;

const RedirectPodcastContainer = styled.div`
  width: 100%;
  max-width: 80%;
  @media (max-width: ${screenSmMax}) {
    max-width: 100%;
  }
`;

const RedirectSection = styled.div`
  margin-top: 64px;
`;

export {
  RedirectSection,
  RedirectPodcastParagraph,
  RedirectPodcastContainer,
  FieldGroup,
};
